import { GridListLabel } from '@app/components/base/content-structure/GridListLabel';
import { ItemsViewLayout } from '@app/components/items-view-layout-switch/ItemsViewLayoutSwitch';
import { StationStatusListItem } from '@app/modules/logger/screens/status/types';
import { Box, Grid } from '@mui/material';
import { FormattedMessage, MessageDescriptor } from 'react-intl';
import { StationGridItems } from './StationGridItems';

interface StatusSectionProps {
  items: StationStatusListItem[];
  variant: ItemsViewLayout;
  onItemWidthChange: (width: number) => void;
  message: MessageDescriptor;
  values?: Record<string, string | number>;
}

/**
 * Renders a titled block of station status cards. Hidden when no item in the section is visible.
 */
export function StatusSection({
  items,
  variant,
  onItemWidthChange,
  message,
  values,
}: StatusSectionProps) {
  const visibleCount = items.filter((item) => item.isVisible).length;

  if (visibleCount === 0) {
    return null;
  }

  return (
    <Box sx={{ mb: 3 }}>
      <GridListLabel>
        <FormattedMessage {...message} values={{ count: visibleCount, ...values }} />
      </GridListLabel>
      <Grid container spacing={2}>
        <StationGridItems items={items} variant={variant} onItemWidthChange={onItemWidthChange} />
      </Grid>
    </Box>
  );
}
